import { Locale } from "@core/schema/Locale.js";

export function calculateDeliveryETA(orderDate: Date, locale: Locale): Date | null {
	if (locale !== Locale.cs) {
		return null;
	}

	const deliveryDate = new Date(orderDate);
	deliveryDate.setDate(deliveryDate.getDate() + 2);

	const deliveryDay = deliveryDate.getDay();

	// If deliveryTime is on weekend -> next Tuesday
	if (deliveryDay === 0 || deliveryDay === 6) {
		const daysUntilTuesday = (9 - deliveryDate.getDay()) % 7;
		deliveryDate.setDate(deliveryDate.getDate() + daysUntilTuesday);
	}

	return deliveryDate;
}
